import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Progress } from "antd";

import { ChevronDownIcon } from "../../../../../../resource/icons";
import declensionWords from "../../../../utils/declensionWords";
import {
	getAnswerFile,
	getAnswerFilePreview,
} from "../../../../store/thunks/get-file";
import Attachment from "../../../../components/attachments/attachment";

const Result = ({ result, question }) => {
	const [shownEntity, showEntity] = useState();
	const otherResults = useSelector(
		(store) => store.votingStore.results.otherResults
	);
	const hereAreSomeFiles = !!question?.answers?.filter((answer) => {
		return !!answer.files?.length && answer.id === result.itemId;
	})?.length;
	let percent = useMemo(
		() => Math.round((result.clientCount / result.allClientCount) * 100),
		[result.clientCount, result.allClientCount]
	);

	if (!result.clientCount) {
		percent = 0;
	}

	const countText =
		question.type.id === 3
			? ["ответ", "ответа", "ответов"]
			: ["голос", "голоса", "голосов"];

	return (
		<div className="result-item" key={result.itemId}>
			{question.type.id !== 3 && (
				<div className="info">
					<span className="percent">{percent}%</span>
					{result.itemText ? (
						<span className="text">{result.itemText}</span>
					) : (
						<span className="text-placeholder">Вариант ответа без текста</span>
					)}
				</div>
			)}
			{question.type.id !== 3 && (
				<Progress
					percent={percent}
					size="small"
					status={"normal"}
					showInfo={false}
				/>
			)}
			<div className="additional-info">
				<div className="count">
					{result.clientCount} {declensionWords(result.clientCount, countText)}
				</div>

				{otherResults?.[result.itemId]?.[0]?.text && (
					<div
						className="show-more"
						onClick={() => {
							if (shownEntity === "otherResults") {
								showEntity(false);
							} else {
								showEntity("otherResults");
							}
						}}
					>
						<span className="text">Ответы</span>
						<ChevronDownIcon
							className={shownEntity === "otherResults" && "chevron-opened"}
						/>
					</div>
				)}
				{hereAreSomeFiles && (
					<div
						className="show-more"
						onClick={() => {
							if (shownEntity === "files") {
								showEntity(false);
							} else {
								showEntity("files");
							}
						}}
					>
						<span className="text">Вложения</span>
						<ChevronDownIcon
							className={shownEntity === "files" && "chevron-opened"}
						/>
					</div>
				)}
			</div>

			{shownEntity === "files" &&
				hereAreSomeFiles &&
				question.answers.map((answer) => {
					if (answer.id === result.itemId) {
						return (
							<div className="attachments" key={answer.id}>
								{answer.files.map((file, index) => {
									return (
										<Attachment
											popup
											key={index}
											getFile={() => {
												return getAnswerFile(answer.id, file.fileName);
											}}
											loadPreview={async () => {
												return await getAnswerFilePreview(
													answer.id,
													file.fileName
												);
											}}
											uploadedFileText={file.name}
										/>
									);
								})}
							</div>
						);
					}
				})}
			{shownEntity === "otherResults" &&
				(result.itemText === "Другое" ||
					result.itemText === "Ваш ответ" ||
					result.itemText === "Свой вариант" ||
					question.type.id === 3) &&
				otherResults[result.itemId] &&
				otherResults[result.itemId].map((otherResult, index) => {
					return (
						<div className="other_result" key={index}>
							<div className="number">{index + 1}</div>
							<div className="text">{otherResult.text}</div>
						</div>
					);
				})}
		</div>
	);
};

export default Result;
